"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreestandingMobileShareIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const FreestandingMobileShareIcon_module_css_1 = __importDefault(require("./FreestandingMobileShareIcon.module.css"));
const ShareSheetPopup_1 = require("../ShareSheetPopup");
const ShareSheetPopupState_1 = require("../ShareSheetPopup/ShareSheetPopupState");
const clsx_1 = require("clsx");
/**
 *
 */
function FreestandingMobileShareIcon({ withTransparency, onShareSheetOpen, onShareSheetClose, shareUrl, pageName, pageType, shareTitle, incrementCounter, withEmbed, lightMode = false, }) {
    const [showShareSheet, setShowShareSheet] = (0, react_1.useState)(ShareSheetPopupState_1.ShareSheetPopupState.UNKNOWN);
    const [sessionOpenTime, setSessionOpenTime] = (0, react_1.useState)(0);
    function closeShareSheet() {
        setSessionOpenTime(0);
        setShowShareSheet(ShareSheetPopupState_1.ShareSheetPopupState.INVISIBLE);
        if (onShareSheetClose) {
            onShareSheetClose();
        }
    }
    function openShareSheet() {
        void incrementCounter(`${pageName}.Share.ShareSheet.Opened`);
        setSessionOpenTime(Date.now());
        setShowShareSheet(ShareSheetPopupState_1.ShareSheetPopupState.VISIBLE);
        if (onShareSheetOpen) {
            onShareSheetOpen();
        }
    }
    const renderShareSheet = () => ((0, jsx_runtime_1.jsx)(ShareSheetPopup_1.ShareSheetPopup, { pageName: pageName, pageType: pageType, url: shareUrl, title: shareTitle, onClose: closeShareSheet, isVisible: showShareSheet, sessionOpenTime: sessionOpenTime, incrementCounter: incrementCounter, withEmbed: withEmbed }));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", { "data-testid": "freestandingMobileShareIcon", type: "button", className: (0, clsx_1.clsx)(FreestandingMobileShareIcon_module_css_1.default.containerDefault, {
                    [FreestandingMobileShareIcon_module_css_1.default.containerWithTransparency]: withTransparency,
                    [FreestandingMobileShareIcon_module_css_1.default.containerLightMode]: lightMode,
                }), onClick: openShareSheet, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.ShareIcon, { size: web_core_ui_1.Sizes.Large }) }), showShareSheet !== ShareSheetPopupState_1.ShareSheetPopupState.UNKNOWN && renderShareSheet()] }));
}
exports.FreestandingMobileShareIcon = FreestandingMobileShareIcon;
//# sourceMappingURL=index.js.map